/* eslint-disable max-len */
import type { CSSProperties } from 'react';

import { novaGradientSvgStop } from '../chat-v2/design-system';

export function NovaRobotIcon({
  className,
  height = 103,
  style,
  width = 103,
}: {
  className?: string;
  height?: number;
  style?: CSSProperties;
  width?: number;
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      focusable="false"
      style={style}
      width={width}
      height={height}
      viewBox="0 0 103 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.5 9.95898C55.2893 9.95898 59.1719 13.8425 59.1719 18.6318C59.1717 21.4861 57.7918 24.017 55.6633 25.5966C54.7059 26.3072 53.9688 27.3496 53.9688 28.5419V34.2412C53.9686 35.2726 54.7644 37.0107 55.7958 37.0107H63.5078C74.3236 37.0107 83.4267 44.0789 86.1156 53.6847C86.3369 54.4751 87.0385 55.0527 87.8594 55.0527C91.173 55.0527 93.8593 57.7391 93.8594 61.0527V66.3965C93.8591 69.71 91.1729 72.3965 87.8594 72.3965C86.8221 72.3965 85.9231 73.0914 85.5628 74.0641C82.3287 82.7937 73.6758 89.042 63.5078 89.042H37.4922C27.3242 89.042 18.6713 82.7937 15.4372 74.0641C15.0769 73.0914 14.1779 72.3965 13.1406 72.3965C9.82708 72.3965 7.14089 69.71 7.14062 66.3965V61.0527C7.14066 57.7391 9.82694 55.0527 13.1406 55.0527C13.9615 55.0527 14.6631 54.4751 14.8844 53.6847C17.5733 44.0789 26.6764 37.0107 37.4922 37.0107H45.2042C46.2356 37.0107 47.0314 35.2726 47.0312 34.2412V28.5419C47.0312 27.3496 46.2941 26.3072 45.3367 25.5966C43.2082 24.017 41.8283 21.4861 41.8281 18.6318C41.8281 13.8425 45.7107 9.95898 50.5 9.95898ZM37.4922 47.1855C28.4615 47.1855 24.6348 54.3849 24.6348 59.5781V66.4736C24.635 71.6669 28.4617 78.8672 37.4922 78.8672H63.5078C73.4385 78.8672 76.3651 71.6669 76.3652 66.4736V59.5781C76.3652 54.3849 71.8878 47.1855 63.5078 47.1855H37.4922ZM38.5 57.5C41.3518 57.5 43.3276 58.7328 44.5234 60.3936C45.6458 61.9524 46 63.7633 46 65C46 66.1046 45.1046 67 44 67C42.8954 67 42 66.1046 42 65C42 64.4035 41.8047 63.4642 41.2773 62.7314C40.8231 62.1006 40.0482 61.5 38.5 61.5C36.9518 61.5 36.1769 62.1006 35.7227 62.7314C35.1953 63.4642 35 64.4035 35 65C35 66.1046 34.1046 67 33 67C31.8954 67 31 66.1046 31 65C31 63.7633 31.3542 61.9524 32.4766 60.3936C33.6724 58.7328 35.6482 57.5 38.5 57.5ZM63.5 57.5C66.3518 57.5 68.3276 58.7328 69.5234 60.3936C70.6458 61.9524 71 63.7633 71 65C71 66.1046 70.1046 67 69 67C67.8954 67 67 66.1046 67 65C67 64.4035 66.8047 63.4642 66.2773 62.7314C65.8231 62.1006 65.0482 61.5 63.5 61.5C61.9518 61.5 61.1769 62.1006 60.7227 62.7314C60.1953 63.4642 60 64.4035 60 65C60 66.1046 59.1046 67 58 67C56.8954 67 56 66.1046 56 65C56 63.7633 56.3542 61.9524 57.4766 60.3936C58.6724 58.7328 60.6482 57.5 63.5 57.5Z"
        fill="url(#nova-empty-state-gradient)"
      />
      <defs>
        <linearGradient
          id="nova-empty-state-gradient"
          x1="7.14063"
          y1="9.95898"
          x2="124.255"
          y2="26.1278"
          gradientUnits="userSpaceOnUse"
        >
          {novaGradientSvgStop.aiBorderIcon.map(({ offset, stopColor }) => (
            <stop key={offset} offset={offset} stopColor={stopColor} />
          ))}
        </linearGradient>
      </defs>
    </svg>
  );
}

export function NovaBackgroundBlob({
  className,
  'data-testid': dataTestId,
  style,
}: {
  className?: string;
  'data-testid'?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      data-testid={dataTestId}
      focusable="false"
      style={style}
      width="309"
      height="202"
      viewBox="0 0 309 202"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.2835 176.597C15.834 172.513 -4.88098 142.201 1.00574 106.849C5.82238 70.0646 59.8729 17.5147 104.826 7.48244C149.779 -2.5498 251.459 -15.9261 292.666 67.1982C333.873 150.323 286.779 201.917 256.81 201.917C226.842 201.917 221.688 168.986 168.51 160.355C115.529 151.755 85.0253 182.808 43.2835 176.597Z"
        fill="#F7FDFC"
      />
    </svg>
  );
}
